import { createRouter, createWebHistory } from 'vue-router';
import Login from '../views/Login.vue';
import NOSPInventory from '../components/NOSPInventory.vue';
import { getItemWithExpiry } from '@/utils/storage';
import UserManagement from '../views/UserManagement.vue';
import { isAdmin } from '@/utils/user-auth';

const routes = [
  {
    path: '/',
    redirect: '/inventory',
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: NOSPInventory,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { 
      requiresAuth: true,
      requiresAdmin: true
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 라우터 가드 설정
router.beforeEach((to, from, next) => {
  const userSession = getItemWithExpiry('userInfo');
  const sessionKey = localStorage.getItem('userSessionKey');
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  
  console.log('userSession:', userSession);
  console.log('requiresAuth:', requiresAuth);
  
  // 인증이 필요한 페이지이고 유효한 세션이 없는 경우
  if (requiresAuth && (!userSession || !sessionKey || !userSession.isUserLogin)) {
    console.log('인증이 필요합니다. 로그인 페이지로 이동합니다.');
    // 로그인 페이지로 리다이렉트
    next('/login');
  } 
  // 관리자 권한이 필요한 페이지에 대한 접근 권한 확인
  else if (requiresAdmin && !isAdmin()) {
    console.log('관리자 권한이 필요합니다. 접근이 거부되었습니다.');
    // 권한이 없으면 인벤토리 페이지로 리다이렉트
    next('/inventory');
  }
  else if (to.path === '/login' && userSession && userSession.isUserLogin) {
    // 이미 로그인되어 있는데 로그인 페이지로 접근하는 경우
    console.log('이미 로그인되어 있습니다. 메인 페이지로 이동합니다.');
    next('/inventory');
  } else {
    // 그 외의 경우 정상적으로 라우팅
    next();
  }
});

export default router; 